
<template>
  <div>
    <div class="products row">
      <div class="grid-2-g grid-1-m hide-s"></div>
      <div class="grid-8-g grid-10-m">
        <div class="row">
          <div class="head column grid-9 grid-12-s">
            <div class="title">
              <strong>{{salutation()}}, {{user.nome}}.</strong> É bom te ver aqui!
            </div>
            <span>Selectione o produto que deseja acessar:</span>
          </div>

          <!-- <div class="row level align-center">
            <img src="../assets/img/light-saber.svg" alt="Sabre de luz" />
            <div>
              Você é um suporter
              <br />
              <strong>Nível 10 - Jedi</strong>
            </div>
          </div>-->
        </div>
        <div class="row column-s justify-space align-center">
          <div class="card column align-center grid-3" @click.self="openModal()">
            <div class="avatar" @click="openModal()">
              <img src="../assets/img/ico_ns_community.svg" />
            </div>
            <div class="title" @click="openModal()">
              <strong>NS</strong> Community
            </div>
            <p>Aprenda e ensine com a Comunidade de supporters.</p>
            <div class="video" @click="modal1.show = true">
              <i class="fa fa-play-circle"></i> Assistir video
            </div>
          </div>

          <div class="card column align-center grid-3" @click.self="openModal2()">
            <div class="avatar" @click="openModal2()">
              <img src="../assets/img/ico_ns_academy.svg" />
            </div>
            <div class="title" @click="openModal2()">
              <strong>NS</strong> Academy
            </div>
            <p>Faça cursos e treinamentos para estar sempre preparado.</p>
            <div class="video" @click="modal2.show = true">
              <i class="fa fa-play-circle"></i> Assistir video
            </div>
          </div>

          <div id="nssupport" class="card column align-center grid-3" @click.self="openModal3()">
            <div class="avatar" @click="openModal3()">
              <img src="../assets/img/ico_ns_support.svg" />
            </div>
            <div class="title" @click="openModal3()">
              <strong>NS</strong> Support
            </div>
            <p>Atenda a comunidade e seja remunerado pra isso.</p>
            <div class="video" @click="modal3.show = true">
              <i class="fa fa-play-circle"></i> Assistir video
            </div>
          </div>
        </div>

        <div class="know row column-s align-center">
          <div
            class="grid"
          >Conheça mais sobre nossos pilares e sobre como cada um deles se relaciona com nossos produtos!</div>
          <router-link to="/dashboard/pilares">
            <Button layout="green-dark" class="grid-12-s justify-center-s row">SAIBA MAIS</Button>
          </router-link>
        </div>
      </div>
    </div>
    <Modal :modal="modal1" />
    <Modal :modal="modal2" />
    <Modal :modal="modal3" />
    <Status />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import Status from "@/components/Status.vue";

export default {
  name: "Products",
  components: {
    Button,
    Modal,
    Status
  },
  data() {
    return {
      modal1: {
        title: "<strong>NS</strong> Community",
        description: "Veja um resumo antes de seu primeiro acesso",
        layout: "Community",
        show: false
      },
      modal2: {
        title: "<strong>NS</strong> Academy",
        description: "Veja um resumo antes de seu primeiro acesso",
        layout: "Academy",
        show: false
      },
      modal3: {
        title: "<strong>NS</strong> Support",
        description: "Veja um resumo antes de seu primeiro acesso",
        layout: "Support",
        show: false
      }
    };
  },

  methods: {
    ...mapActions("user", ["SET_VIDEO"]),
    openModal() {
      if (
        !this.user.video_nscommunity_visualizado ||
        this.user.usuario_discourse.length == 0 ||
        this.user.usuario_discourse == null ||
        this.user.usuario_discourse == "null"
      ) {
        this.SET_VIDEO("nscommunity");
        this.user.video_nscommunity_visualizado = true;
        this.modal1.show = true;
      } else {
        window.open(this.user.ns_community, "_blank");
      }
    },
    openModal2() {
      if (!this.user.video_nsacademy_visualizado) {
        this.SET_VIDEO("nsacademy");
        this.user.video_nsacademy_visualizado = true;
        this.modal2.show = true;
      } else {
        window.open(this.user.ns_academy, "_blank");
      }
    },
    openModal3() {
      if (!this.user.video_nssupport_visualizado) {
        this.SET_VIDEO("nssupport");
        this.user.video_nssupport_visualizado = true;
        this.modal3.show = true;
      } else {
        window.location = "/supporter/dashboard";
      }
    },
    salutation() {
      let time = new Date();
      let hour = time.getHours();
      if (hour > 7 && hour < 13) return "Bom dia";
      else if (hour > 12 && hour < 19) return "Boa tarde";
      else return "Boa noite";
    }
  },
  computed: {
    ...mapGetters("user", ["user"])
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.products {
  color: $gray-1;
  .head {
    @media (max-width: $small) {
      align-items: center;
      padding: 10px;
    }
    span {
      font-size: 19px;
      @media (max-width: $small) {
        font-size: 15px;
      }
    }
  }
  .title {
    padding-top: 90px;
    @media (max-width: $small) {
      padding: 20px;
      padding-top: 45px;
      font-size: 20px;
    }
    @media (max-width: $medium) and (min-width: $small) {
      font-size: 20px;
    }
    font-size: 27px;
    color: $black;
    font-weight: 500;
  }
  .level {
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 100px;

    height: 52px;
    width: 195px;
    color: $gray-5;
    font-size: 12px;
    img {
      margin-right: 9px;
      margin-left: 10px;
      margin-top: -25px;
    }
    strong {
      color: $gray-1;
      font-size: 14px;
    }
  }

  & .card {
    margin-top: 65px;
    max-height: 188px;
    overflow: hidden;
    @media (max-width: $small) {
      margin-top: 25px;
      width: 75%;
    }

    @media (min-width: 850px) AND (max-width: 870px) {
      width: 165px;
      max-height: 180px;
    }
    background: $white;
    box-shadow: $shadow;
    padding: 31px;
    border-radius: 5px;
    cursor: pointer;
    .title {
      font-weight: bold;
      color: $green-6;
      padding-top: 12px;
      strong {
        color: $green-7;
      }
    }
    p {
      padding-top: 15px;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
    }

    &:hover {
      opacity: 0.8;
      background: $green-7;
      p,
      strong,
      .title {
        color: $white;
      }
      .video {
        margin-top: 0px;
      }
    }

    .video {
      margin-top: 100%;
      color: $white-3;
      &:hover {
        color: $black;
      }
    }
  }
  .avatar {
    width: 72px;
    height: 72px;
  }
  .know {
    margin-top: 65px;
    @media (max-width: $small) {
      padding: 0px 12%;
      padding-bottom: 50px;
      text-align: center;

      & div {
        margin-bottom: 25px;
      }
    }
    button {
      @media (max-width: $small) {
        height: 35px;
        line-height: 20px;
      }
    }
  }
}
</style>
